import PageTitle from 'components/PageTitle';

import Section from '../components/Section';
import { InlineClippedImage } from '../components/InlineClippedImage';
import ContentTypeNav from 'components/ContentTypeNav';

import signature from '../assets/images/tg-signature.png';

import Connell_2008_Woods_and_Roses from '../assets/images/content/Connell_2008_Woods_and_Roses.jpg';
import Connell_2015_Undercurrent from '../assets/images/content/Connell_2015_Undercurrent.jpg';
import Connell_2003_Chamomile from '../assets/images/content/Connell_2003_Chamomile.jpg';
import Connell_2002_Kitchen_Tension from '../assets/images/content/Connell_2002_Kitchen_Tension.jpg';
import Connell_2002_Picnic from '../assets/images/content/Connell_2002_Picnic.jpg';
import stay_well_be_kind from '../assets/images/stay_well_be_kind.svg';
import Connell_2008_Backgammon from '../assets/images/content/Connell_2008_Backgammon.jpg';

const Q2LetterToShareholders = () => {
	return (
		<>
			<PageTitle title="Letter to Shareholders" />

			<div id="introduction" className="bg-[#D1E5DF] py-12 md:py-24">
				<div className="container max-w-[1068px]">
					<div className="md:max-w-[873px]">
						<ContentTypeNav type="letter" />
						<p className="font-late-serif text-[1.375rem] md:text-[1.65rem] leading-[1.6] mb-6">For the second quarter 2025, we continued to post solid companywide results in growth in both net premiums written (NPW) and policies in force (PIF) year over year (YOY), with very healthy margins, what we would call the trifecta. More specifically, YOY for the quarter, NPW growth was 12%, PIF growth was 15%, and our combined ratio (CR) was 86.2. We have grown PIFs over 5 million YOY, on an already large book of business, while providing excellent customer service. We now have over 37 million PIFs and will continue to use the levers we have as we seek to profitably grow in every area of the business. Our claims and customer relationship management groups are well staffed and ready for whatever comes our way, including weather. There are still some unknowns surrounding the effect of the trade tariffs, but we are watching the data closely and will react accordingly.</p>
					</div>
				</div>
			</div>

			<div id="leading-brand" className="py-0 md:py-24">
				<div className="grid md:grid-cols-[1fr_1fr] gap-12 container">
					<div className="grid">
						<div className="md:max-w-[520px] ml-auto">
							<p>
								In Personal Lines (auto, special lines, and property) we continued to deliver the rare combination of remarkable growth and strong profitability. We added nearly 1 million policies during the second quarter 2025, bringing our total to more than 36 million PIFs, reflecting growth of 16% YOY. This marked the fifth consecutive quarter of double-digit YOY PIF growth. Personal Lines grew NPW 15% during the second quarter YOY at a combined ratio of 86.0. During the second quarter, our personal vehicle business grew NPW 16% YOY and reported a CR of 86.2, well below our target. Last year’s record growth creates challenging growth rate comparisons. That said, we generated new business application growth of 7% in our personal vehicle business during the second quarter 2025. In the personal property business, continued initiatives to reduce risk in markets susceptible to volatile weather contributed to achieving a CR of 83.6 for the second quarter 2025. We
								continue to focus on driving growth across channels and lines of business through significant advertising, a variety of agent incentives, adjusting rates, and other non-rate actions where margins permit us to do so. Recognizing that price remains the largest driver of insurance shopping and switching, we continue to closely manage non-acquisition expenses and year to date, through June, our vehicle non-acquisition expense ratio decreased 0.3 points.
							</p>

							<p>Our personal auto business continued to experience robust growth and profit, with a 19% YOY increase in PIFs and a favorable CR of 85.9 for the second quarter. Driven by strong new applications and retention of existing policyholders, NPW increased 16% YOY compared to the second quarter last year. During the second quarter 2025, we continued to see an increase in severity, which was predominantly offset by a decline in loss frequency and an increase in average earned premiums, and our quarterly results were not materially affected by significant weather events or prior period development. Both shopping and conversion rates for auto increased during the second quarter YOY, resulting in an 8% increase in new application growth. Throughout the quarter, rates remained relatively stable as we continued to closely monitor business trends and assess the potential impact of tariffs on pricing.</p>
						</div>
					</div>
					<div className="md:max-w-[583px] ml-auto">
						<div>
							<InlineClippedImage
								src={Connell_2008_Woods_and_Roses}
								alt="Art"
								dimensions={{
									width: 1920,
									height: 1440,
								}}
								clipPaths={[
									{
										initial: {
											x: '45%',
											y: '3%',
											width: '45%',
										},
										expanded: {
											x: '0%',
											y: '0%',
											width: '100%',
										},
									},
								]}
							/>
						</div>
					</div>
				</div>
				<div className="grid md:grid-cols-[1fr_1fr] gap-12 container">
					<div className="grid">
						<div className="md:max-w-[520px] ml-auto mt-12 md:mt-0">
							<p>Our latest personal auto product model, 8.9, is now available in 24 states that accounted for 46% of auto NPW on a trailing 12-month basis at the end of the second quarter 2025. This model continues to demonstrate favorable conversion results and elasticity. Additionally, our Snapshot® 5.0 product model, which includes an app-based tool capable of detecting major accidents and offering to promptly connect customers to towing and emergency services, is now deployed in states representing 78% of companywide personal auto NPW on a trailing 12-month basis (excluding California).</p>
						</div>
						<div className="md:max-w-[583px] mx-auto mt-12 md:mt-auto">
							<InlineClippedImage
								src={Connell_2015_Undercurrent}
								alt="Art"
								dimensions={{
									width: 1920,
									height: 1440,
								}}
								clipPaths={[
									{
										initial: {
											x: '55%',
											y: '26%',
											width: '40%',
										},
										expanded: {
											x: '0%',
											y: '0%',
											width: '100%',
										},
									},
								]}
							/>
						</div>
					</div>
					<div>
						<div className="md:max-w-[520px]">
							<p>
								Our personal property business delivered another profitable quarter, running an 83.6 CR. Net catastrophe losses were partially offset by favorable prior accident year development, primarily related to prior-year weather events. We ended the second quarter 2025 with over 3.6 million PIFs, an increase of 8% over the second quarter last year, driven primarily by growth in our renters business. Year-over-year NPW growth (2%) was lower than PIF growth for the quarter, driven by a continued mix shift towards lower exposure (and lower average premium) products and geographies, such as renters and markets less prone to catastrophe events. We continue to focus on profitability by prioritizing insuring lower-risk properties (e.g., new construction, existing homes with newer roofs), only accepting new business when bundled with a Progressive auto policy (where allowed), and reducing exposure in catastrophe-prone markets. During the second quarter, homeowners PIFs
								increased 7% in markets where we are looking to expand and decreased 15% in markets where we are looking to reduce risk.
							</p>

							<p>We continued to make good progress on advancing our personal property product and segmentation capabilities and, through the end of the second quarter 2025, we elevated our next generation 5.0 or higher product models in 29 states that represent over 75% of our trailing 12-month homeowners product NPW. Key features of 5.0+ include expanded peril rating and the introduction of new rating variables. We also continue to adjust rates where needed, and during the second quarter we increased our personal property rates about 4% overall, bringing our trailing 12-month aggregate rate increase to about 14%.</p>

							<p>Our Commercial Lines (CL) business finished the second quarter with 6% PIF growth at an 86.8 CR. Despite positive PIF growth, NPW decreased 6% in the quarter, compared to the prior year, driven primarily by a shift in renewal timing for certain transportation network company (TNC) business policies and, to a lesser extent, a mix shift to lower average written premium business market targets (BMT) in our core commercial auto business.</p>
						</div>
					</div>
				</div>
			</div>

			<div className="container py-0 md:py-24">
				<img src={stay_well_be_kind} alt="stay_well_be_kind" className="" />
			</div>

			<Section backgroundColor="#F1F7F6">
				<div className="md:grid md:grid-cols-[1fr_1fr] gap-12 px-4 sm:px-6">
					<div className="md:max-w-[520px] ml-auto ">
						<p>One of our TNC customers was previously on a 6-month policy term with renewal events in April and October each year. In October 2024, the customer moved to a 12-month policy term, resulting in there not being a renewal event or related NPW in April of this year. Excluding all TNC business, our total CL NPW for the quarter would have decreased 2%, compared to the second quarter 2024. In core commercial auto, we continued to see strong growth in our business auto and contractor BMTs during the quarter, driven by quote and conversion improvements, but also continued to face challenges in our for-hire trucking and for-hire specialty BMTs, which have higher average written premiums per policy than our business auto and contractor BMTs. This mix shift resulted in lower NPW for core commercial auto in the quarter compared to the prior year.</p>
					</div>
				</div>
				<div className="md:grid md:grid-cols-[1fr_1fr] gap-12 px-4 sm:px-6">
					<div className="md:max-w-[520px] ml-auto">
						<p>Our newest core commercial auto product offering, model 8.3, elevated in the first state in the first quarter 2025, and we expect the future rollout to include 13 additional states by the end of 2025, pending regulatory approval. Those 14 states represented 46% of our countrywide trailing 12-month written premium. The 8.3 model brings new external data to improve segmentation and better match rate to risk. We expanded availability of our new cargo plus endorsement in the quarter, which was available in 47 states as of the end of the second quarter 2025. The cargo plus endorsement expands coverage to better meet the needs of our for-hire transportation customers.</p>
					</div>
					<div className="md:max-w-[520px] grid">
						<div className="mt-auto">
							<p>In the second quarter of 2025, our total net investment income contributed to about half of our total comprehensive income. Our investment portfolio saw a return of 2.1% and remained in a relatively conservative posture. Our fixed-income return was 1.7% for the quarter and our common equity portfolio returned 10.9%.</p>

							<p>The combined strength in performance from the operating and investing sides of our business this year has driven significant growth in our capital base. We finished the second quarter with our debt-to-total capital ratio below 18% and have no bond maturities until 2027. While it is a comfort in these volatile times to be in such a strong financial position, we are mindful of the fact that holding excess capital over longer periods of time could depress our returns on capital. We will continue to attempt to strike a balance between maintaining the competitive advantage of such a strong financial position while seeking to continue to drive robust returns on our capital.</p>
						</div>
					</div>
				</div>
			</Section>

			<div>
				<div className="grid grid-cols-1 gap-4 items-stretch mt-24 mb-8 md:grid-cols-3">
					<img src={Connell_2003_Chamomile} alt="Connell_2024_Still_Summer" className="w-full h-auto" />
					<img src={Connell_2002_Kitchen_Tension} alt="Connell_2002_Kitchen_Tension" className="w-full h-auto" />
				</div>
				<div className="md:grid md:grid-cols-[56%_1fr] gap-12">
					<div className="md:max-w-[534px] order-1 ml-auto py-12 px-4 sm:px-6">
						<p>It’s something of a tradition for me to use this letter to share stories that bring our one-of-a-kind employee culture to life. I know the word “culture” has gotten a little cliché these days, but for Progressive people, we truly take our company’s purpose of helping others move forward and live fully very seriously. We do this in both big and small ways every day. I hear so many wonderful stories and there’s only so much room to share them, so here are just a couple of stories that filled me with pride recently.</p>

						<p>Six months after starting at Progressive, Heather, a Commercial Lines claims employee, volunteered with the Community Involvement group at her office in Alabama for the first time. That was back in early 2021, and now Heather oversees the office’s volunteer activities.</p>
					</div>
				</div>
				<div className="md:grid md:grid-cols-[56%_1fr] gap-12 px-4 sm:px-6">
					<div className="order-1 md:grid">
						<div className="md:max-w-[563px] h-[422.25px] mr-auto">
							<InlineClippedImage
								src={Connell_2008_Backgammon}
								dimensions={{
									width: 1920,
									height: 1440,
								}}
								clipPaths={[
									{
										initial: {
											x: '56%',
											y: '4%',
											width: '38%',
										},
										expanded: {
											x: '0%',
											y: '0%',
											width: '100%',
										},
									},
								]}
							/>
						</div>
					</div>
					<div className="max-w-[550px] order-2 mr-auto">
						<p>
							<span className="text-[#F05860] font-late-serif">“I absolutely love our Community Involvement group because we put our hands into so many different things,”</span> says Heather. <span className="text-[#F05860] font-late-serif">“We’re all passionate and want to be involved in a variety of events to give back.”</span>
						</p>

						<p>When an employee at her office recommended that the group volunteer with a local charity to pack bags of food for students, the team dove right in to help kids at risk of food insecurity.</p>

						<p>
							<span className="text-[#F05860] font-late-serif">“You see some misty eyes from the volunteers when they start thinking about the fact that they’re packing food for kids who have no idea how they’re going to eat that weekend,” </span> shares Heather. <span className="text-[#F05860] font-late-serif">“It breaks my heart, but the work is so rewarding.”</span>
						</p>
						<p>
							The group normally volunteers the first Saturday of every month during off-work hours but when Progressive started offering volunteer time off—eight hours per year during the workweek to volunteer with pay—it enabled them to help even more. With their managers’ support, the team is exploring more ways to help their community.
							<span className="text-[#F05860] font-late-serif"> “Wherever you can go to help, even if it’s just for one person, you can make such a giant impact,”</span> says Heather.
							<span className="text-[#F05860] font-late-serif"> “You can change the world just by getting out there and doing something.”</span>
						</p>

						<p>Ashley, a catastrophe claims rep based in Texas, often meets our customers in times of great distress. In the aftermath of a recent storm, she noticed that, for many of the people she helped, their number one concern wasn’t their car or truck, but rather their elderly parents or young children:</p>

						<p className="text-[#F05860] font-late-serif">“After being out in the field for a couple of days, I realized that it was very difficult for people to get food, water, and basic hygiene items. So, I stopped at a grocery store and bought a couple cases of water, baby wipes, hand sanitizer, and snacky items like granola bars or, my personal favorite, Oreos. I handed these items out while inspecting customers’ homes and took the time to listen to their concerns and give them hugs while they cried and wondered if they could rebuild their homes. Sharing Oreos may not be a lot in the grand scheme of things, but it felt like it made a difference, and it made me aware of how much impact we can have not only for our customers, but their communities, as well.”</p>

						<p>I wanted to end this letter paying homage to Glenn Renwick, our prior CEO who was also my coach, mentor, and friend. He passed away in May. If you have ever heard me talk about my career, you know that I give him credit for taking a chance on me in 2002 when he gave me the opportunity to take the role as Chief Human Resources Officer for the company. His trust and support remained unwavering for the next 16 years as we worked side by side. I learned something from him every day.</p>

						<p>His contributions to Progressive were enormous, but one of the first things that comes to mind as I reflect on his work was his commitment to our Core Values. He was the standard bearer for them, living them fully and intentionally every day. He was an incredible leader and all he ever wanted to do was leave Progressive better than he found it. Without doubt, he accomplished that, and so much more.</p>

						<p>
							Glenn often ended his shareholders letters with a play on our name:
							<br /> <span className="text-[#F05860] font-late-serif">To all the people who make Progressive, progressive – Thank you.</span>
						</p>

						<p>Thank you, Glenn, for all of your guidance and extraordinary leadership. You will be dearly missed. Rest in Peace.</p>

						<p className="mb-6">Stay well and be kind to others,</p>
						<img src={signature} className="max-w-[255px]" alt="" />
						<p>
							Tricia Griffith <br /> President and Chief Executive Officer
						</p>
					</div>
				</div>
			</div>

			<div className="container grid py-24">
				<div className="max-w-[1114px] mr-auto">
					<InlineClippedImage
						src={Connell_2002_Picnic}
						dimensions={{
							width: 1920,
							height: 1440,
						}}
						clipPaths={[
							{
								initial: { x: '51%', y: '5%', width: '44%' },
								expanded: { x: '0%', y: '0%', width: '100%' },
							},
						]}
					/>
				</div>
			</div>
		</>
	);
};

export default Q2LetterToShareholders;
